import type { Ref } from 'vue'
import type { RouteLocationNormalizedLoaded } from 'vue-router'
import { QueryParams } from '@/const/CarrierMessagesListQueryFilters'
import { appendToParams } from '@/services/Url'

type Input = {
  route: RouteLocationNormalizedLoaded
  serverOptions: Ref
  detailed: boolean
  baseFilter: Record<string, string>
}

export const makeRequestParams = ({ route, serverOptions, detailed, baseFilter }: Input) => {
  const params = new URLSearchParams({
    ...baseFilter,
    limit: String(serverOptions.value.rowsPerPage || 50),
    page: String(serverOptions.value.page || 1),
  })

  /**
   * If not detailed view is requested, we are not applying any extra filters to not make the filters from parent
   * table get in the way of messages table (non-detailed messages table is rendered in shipments feed which uses
   * the same filtering concept)
   */
  if (!detailed) {
    return params
  }

  if (route?.query.item) {
    const appender = appendToParams(params, QueryParams.ITEM)
    String(route.query.item).split(',').forEach(appender)
  }

  if (route?.query.dateFrom) {
    params.append(QueryParams.DATE_FROM, String(route.query.dateFrom))
  }

  if (route?.query.dateTo) {
    params.append(QueryParams.DATE_TO, String(route.query.dateTo))
  }

  if (route?.query.senderType) {
    params.append(QueryParams.SENDER_TYPE, route.query.senderType.toString().trim())
  }

  return params
}
